/* eslint-disable @typescript-eslint/naming-convention */
export const COURIER_DATA_UPDATED = 'courier_data_updated';
